import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {Error505Component} from './components/error505/error505.component';
import {MainComponent} from './components/main/main.component';
import {Error400Component} from './components/error400/error400.component';
import {ContactComponent} from './components/contact/contact.component';

// Importar componentes

const appRoutes: Routes = [
  {path: 'wow/:unique', component: MainComponent},
  {path: 'wow/preview/:unique/:token', component: MainComponent},
  {path: 'err400', component: Error400Component},
  {path: 'wow/contact/:unique', component: ContactComponent},
  {path: '**', component: Error505Component},
  {path: '', component: Error505Component},
  {path: 'wow/preview/:unique/:token', component: MainComponent}
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts